import { FC, PropsWithChildren, ReactNode } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type PageLayoutProps = {
  name?: ReactNode;
};

const PageLayout: FC<PropsWithChildren<PropsWithClassName<PageLayoutProps>>> = ({ children, className, name }) => {
  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {name ? (
        <div className="flex">
          <div className="font-bold text-base text-secondary-content bg-secondary-400 rounded-3xl px-6 py-4">
            {name}
          </div>
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default PageLayout;
